import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Flex, Image, ListItem, Stack, Text, UnorderedList } from '@chakra-ui/react'
import { ContentLabel } from './Insurer'
import { DocumentsList } from '@/components/Documents/DocumentsList'
import { AppSettings } from '@/appSettings'

const baseUrl = AppSettings.baseUrl + '/docs/koop/'

const KoopContent = () => {
  return (
    <Stack m={4} gap={10}>
      <Documents />
    </Stack>
  )
}

export default KoopContent

const Documents = () => {
  return (
    <Stack>
      <Flex justifyContent='center' >
        <Text fontSize='4xl'>Dokumenty</Text>
      </Flex>

      <Stack gap={16} sx={{
        backgroundColor: 'white',
        p: 6
      }}>
        <DocumentsList items={[
          {
            url: baseUrl + 'koop_produktova_karta.pdf',
            name: 'Produktová karta',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_argumentacni_karta.pdf',
            name: 'Argumentační karta',
            documentType: 'pdf'
          }
        ]} />

        <DocumentsList items={[
          {
            url: baseUrl + 'koop_vpp.pdf',
            name: 'Všeobecné pojistné podmínky pro pojištění vozidel',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_dokument_pojisteni_vozidel_ipid.pdf',
            name: 'Informační dokument o pojistném produktu - IPID',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_asistencni_sluzby_do35.pdf',
            name: 'Asistenční služby pro vozidla do 3,5 t',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_asistencni_sluzby_nad35.pdf',
            name: 'Asistenční služby pro vozidla nad 3,5 t',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_samofoceni_pokyny.pdf',
            name: 'Samofocení - POKYNY K PROVEDENÍ PROHLÍDKY VOZIDLA',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_samofoceni_pokyny_a_informace_pro_prodejce.pdf',
            name: 'Samofocení - pokyny a informace pro prodejce',
            documentType: 'pdf'
          },
          {
            url: baseUrl + 'koop_samofoceni_QaA.pdf',
            name: 'Samofocení - nejčastější dotazy',
            documentType: 'pdf'
          }
        ]} />

        <DocumentsList items={[
          {
            url: baseUrl + 'koop_priloha_16_informace_pro_klienta.pdf',
            name: 'Informace pro klienta',
            documentType: 'pdf'
          }
        ]} />

        <Accordion allowToggle>
          <AccordionItem>
            <AccordionButton bg='blue.600' color='white' _hover={{ bg: 'blue.700' }}>
              <Box as='span' flex='1' textAlign='center' fontWeight={'bold'}>
                Dokumenty k produktu GL2 - smlouvy sjednané do 11.5.2021
              </Box>
              <AccordionIcon />
            </AccordionButton>

            <AccordionPanel>
              <Stack gap={16} sx={{
                backgroundColor: 'white',
                paddingY: 6
              }}>
                <DocumentsList items={[
                  {
                    url: baseUrl + 'gl2/R_630_14.pdf',
                    name: 'Všeobecné pojistné podmínky pro pojištění odpovědnosti za škodu způsobenou provozem vozidla R-630/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_350_14.pdf',
                    name: 'Všeobecné pojistné podmínky pro havarijní pojištění H-350/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_361_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro pojištění zavazadel H-361/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_362_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové úrazové pojištění osob dopravovaných vozidlem (H 362/14)',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_363_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro pojištění nákladů na nájem náhradního vozidla H-363/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_364_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové pojištění skel vozidla (H 364/14)',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_365_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové pojištění KoopGAP (H 365/14)',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_371_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové živelní pojištění vozidla H-371/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_372_14.pdf',
                    name: '>Zvláštní pojistné podmínky pro doplňkové pojištění poškození vozidla zvířetem (H-372/14)',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_956_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové pojištění právní ochrany vozidla (H-956/14)',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_959_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové pojištění právní ochrany – dopravní nehoda H-959/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_380_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro havarijní pojištění při nezaviněné nehodě – NA100PRO H-380/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/H_390_14.pdf',
                    name: 'Zvláštní pojistné podmínky pro doplňkové pojištění asistenčních služeb k vozidlu H-390/14',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/asist_sesit.pdf',
                    name: 'Asistenční sešit',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/koop_dokument_pojisteni_vozidel_ipid.pdf',
                    name: 'Informační dokument o pojistném produktu - IPID',
                    documentType: 'pdf'
                  }
                ]} />

                <DocumentsList items={[
                  {
                    url: baseUrl + 'gl2/koop_prohlidka_letak.pdf',
                    name: 'Prohlídka vozidla při vstupu do pojištění - tzv. samofocení',
                    documentType: 'pdf'
                  },
                  {
                    url: baseUrl + 'gl2/koop_prohlidka_pokyny.pdf',
                    name: 'Pokyny k provedení prohlídky vozidla',
                    documentType: 'pdf'
                  }
                ]} />
              </Stack>
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Stack>
    </Stack >
  )
}